<template>
  <div class="grid-container">
    <div v-if="dataHome" class="grid-x align-center">
      <div class="cell small-12 medium-8 large-8 action">
        <h3 class="action__title">FORMA PARTE DE DEPORSTAR:</h3>
        <p class="action__text">
          {{ dataHome.text1 }}
        </p>
        <router-link 
          :to="{name: 'login'}"
          class="action__link" 
          href="#">
            Crear un torneo
        </router-link>
      </div>
    </div>
    <div v-else>
      <app-loading />
    </div>
  </div>
</template>

<script>

  import { mapGetters } from 'vuex'
  //

  export default {
    name: 'TheLlamadaAccionSecundaria',
    computed: {
      ...mapGetters({
        loadHome: 'loadHome',
        dataHome: 'dataHome',
      })
    }
  }
</script>

<style lang="scss" scoped>
  .action {
    padding: 2em;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    &__title {
      font-size: 16px;
      font-weight: bold;
      font-family: $ff-1;
      color: $color-1;
      @include desde($large) {
        font-size: 24px;
        margin-bottom: 10px;
      }
    }
    &__text {
      font-size: 12px;
      font-family: $ff-2;
      margin-bottom: 1em;
      text-align: center;
      @include desde($large) {
        font-size: 16px;
        margin-bottom: 1em;
      }
    }
    &__link {
      background: $color-2;
      padding: 7px 20px;
      font-family: $ff-4;
      text-align: center;
      color: $color-white;
      text-decoration: none;
      border-radius: 10px;
      &:hover {
        opacity:0.6;       
      }
    }
  }
</style>